import React from 'react';

const Block = function (props: {className?: string, padding?: string, children: React.ReactNode}) {
  const { className, padding, ...rest } = props;
  return (
    <div
      className={`border border-[#d4d9dc] ${props.className ? props.className : ''}`}
      style={{
        padding: props.padding ? props.padding : '20px 20px 10px',
      }}
      {...rest}
    />
  );
};

export default Block;
